import DocumentProcessorScreen from './containers/documentProcessorScreen'

export {default as DocumentProcessorScreenLayout} from './components/documentProcessorScreenLayout'

export default DocumentProcessorScreen
